// extracted by mini-css-extract-plugin
export default {"fab":"CreateAction_fab__YDQnQ"};